import { render, staticRenderFns } from "./CardbagDetails.vue?vue&type=template&id=73a042fa&scoped=true&"
import script from "./CardbagDetails.vue?vue&type=script&lang=js&"
export * from "./CardbagDetails.vue?vue&type=script&lang=js&"
import style0 from "./CardbagDetails.vue?vue&type=style&index=0&id=73a042fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a042fa",
  null
  
)

export default component.exports